import React, { Component } from "react";
import { connect } from "react-redux";
import classNames from "classnames";
import Geosuggest from "react-geosuggest";
import moment from "moment";

import CanvasActions from "../../actions/CanvasActions.js";

import "./style.css";

class Location extends Component {
  render() {
    return (
      <div className="location-picker">
        <div className="info">
          <p>Where was your moment?</p>
        </div>
        <Geosuggest
          initialValue={
            this.props.canvas.locationText ? this.props.canvas.locationText : ""
          }
          onSuggestSelect={e => {
            if (e) {
              this.props.setCanvas({
                ...this.props.canvas,
                lat: e.location.lat,
                lng: e.location.lng,
                locationText: e.description
              });
            }
          }}
        />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    canvas: state.canvas
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setCanvas: canvas => {
      dispatch(CanvasActions.setCanvas(canvas));
    }
  };
};

const App = connect(
  mapStateToProps,
  mapDispatchToProps
)(Location);

export default App;



// WEBPACK FOOTER //
// ./src/components/Location/index.js